/** Default monthly partner portal fee (AED) when admin omits amount on accept. */
export const DEFAULT_PARTNER_ACCEPT_AMOUNT = 49;

export const normalizePartnerAcceptAmount = (value) => {
  if (value === '' || value == null) return null;
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : NaN;
};

export const isPartnerAcceptAmountValid = (value) => {
  const amount = normalizePartnerAcceptAmount(value);
  return Number.isFinite(amount) && amount > 0;
};

/** PATCH /admin/partners/:id/status body for live. */
export const buildPartnerLiveStatusPayload = (amount = DEFAULT_PARTNER_ACCEPT_AMOUNT) => {
  const normalized = normalizePartnerAcceptAmount(amount);
  return {
    status: 'live',
    amount:
      Number.isFinite(normalized) && normalized > 0 ? normalized : DEFAULT_PARTNER_ACCEPT_AMOUNT,
  };
};

/** PATCH /admin/partners/:id/subscription-pricing body. */
export const buildPartnerSubscriptionPricingPayload = (amount) => {
  const normalized = normalizePartnerAcceptAmount(amount);
  if (!Number.isFinite(normalized) || normalized <= 0) {
    return null;
  }
  return { amount: normalized };
};

/** Normalize `subscriptionPlan` from accept-partner / pricing / partners-list response. */
export const normalizeAcceptedSubscriptionPlan = (plan) => {
  if (plan == null || typeof plan !== 'object') return null;

  const amount = Number(plan.amount);
  const billingPeriodMonths = Number(plan.billingPeriodMonths);

  return {
    pricingId: plan.pricingId ?? plan.id ?? null,
    name: String(plan.name ?? 'Partner Portal').trim() || 'Partner Portal',
    amount: Number.isFinite(amount) ? amount : null,
    currency:
      String(plan.currency ?? 'AED')
        .trim()
        .toUpperCase() || 'AED',
    active: plan.active !== false,
    billingPeriodMonths:
      Number.isFinite(billingPeriodMonths) && billingPeriodMonths > 0 ? billingPeriodMonths : 1,
  };
};

export const formatAcceptedSubscriptionPlanSummary = (plan) => {
  const normalized = normalizeAcceptedSubscriptionPlan(plan);
  if (!normalized || normalized.amount == null) return null;

  const period =
    normalized.billingPeriodMonths === 1 ? 'mo' : `${normalized.billingPeriodMonths} mo`;
  return `${normalized.name}: ${normalized.amount} ${normalized.currency}/${period}`;
};

/** Compact fee label for partner list cells, e.g. "99 AED/mo". */
export const formatPartnerSubscriptionFeeLabel = (plan) => {
  const normalized = normalizeAcceptedSubscriptionPlan(plan);
  if (!normalized || normalized.amount == null) return null;

  const period =
    normalized.billingPeriodMonths === 1 ? 'mo' : `${normalized.billingPeriodMonths} mo`;
  return `${normalized.amount} ${normalized.currency}/${period}`;
};
